import HttpClient from 'flow-doctor-lib/constants/HttpClient';
import { registerQuery } from 'data-fetching-client';
export const GET_OBJECT_TYPE_DEFINITION = registerQuery({
  fieldName: 'objectTypeDefinition',
  args: ['objectTypeId', 'portalId'],
  fetcher({
    objectTypeId,
    portalId
  }) {
    return HttpClient.get(`inbounddb-meta/v1/object-types/${objectTypeId}`, {
      query: {
        portalId
      }
    });
  }
});
export const GET_OBJECT_TYPES_FOR_PORTAL = registerQuery({
  fieldName: 'portalSpecificObjects',
  args: ['portalId'],
  fetcher({
    portalId
  }) {
    return HttpClient.get('inbounddb-meta/v1/object-types/meta-types/portal-specific', {
      query: {
        portalId
      }
    });
  }
});